import styled from 'styled-components';

interface MobileProps {
	isMobile: boolean;
}

export const Base = styled.div<MobileProps>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: ${(p) => (p.isMobile ? '70px' : '90px')};
	flex-shrink: 0;
	background: ${(p) => p.theme.gray[0]};
	padding-right: ${(p) => (p.isMobile ? '16px' : '22px')};
`;

export const Logo = styled.svg<MobileProps>`
	width: ${(p) => (p.isMobile ? '90px' : '109px')};
	height: ${(p) => (p.isMobile ? '28px' : '35px')};
	margin-left: 12px;
	margin-bottom: 2px;

	path {
		fill: ${(p) => p.theme.gray[1000]};
	}
`;

export const Title = styled.div<MobileProps>`
	margin-left: ${(p) => (p.isMobile ? '20px' : '36px')};
	display: ${(p) => (p.isMobile ? 'flex' : 'block')};
	align-items: ${(p) => (p.isMobile ? 'center' : 'initial')};
	gap: ${(p) => (p.isMobile ? '8px' : '0')};
`;

export const ProfileButton = styled.div<MobileProps>`
	// layout
	width: ${(p) => (p.isMobile ? '60px' : '80px')};
	height: ${(p) => (p.isMobile ? '40px' : '42px')};
	display: flex;
	align-items: center;
	justify-content: center;
	gap: ${(p) => (p.isMobile ? '4px' : '8px')};

	// style
	background: transparent;
	border: 0px solid transparent;
	border-radius: 18px;
	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}

	// Hide the dropdown arrow on mobile
	> div:last-child {
		display: ${(p) => (p.isMobile ? 'none' : 'flex')};
	}
`;
